// extracted by mini-css-extract-plugin
export var card = "_mc-5";
export var cardSelected = "_mc-4";
export var image = "_mc-3";
export var modal = "_mc-0";
export var modalContent = "_mc-1";
export var table = "_mc-2";